import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import TimeStamp from '../parts/TimeStamp';
import TimelinePanel from '../panels/TimelinePanel';
import TimelineProgress from '../parts/TimelineProgress'
import AddTimeline from '../parts/AddTimeline'
import { TimelineLabelType, TimelineIconType } from "../../../constants/ComponentTypes";
import { connect } from 'react-redux';

const styles = () => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    width: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
  },

  mainContainer: {
    flex: '4',
    position: 'relative',
    overflowY: 'scroll',
    boxSizing: 'border-box',
    padding: '20px 20px 0px 20px',
  },
  labelContainer: {
    width: '100%',
    padding: '0 220px',
    boxSizing: 'border-box',
    margin: '3px 0px 15px 0px',
    display: 'flex',
    alignItems: 'center',
  },

  label: {
    fontWeight: 'bold',
    fontSize: '14px',
    padding: '0px 10px',
    whiteSpace: 'nowrap',
    color: '#5A5B62',
  },

  statuses: {
    width: '100%',
    position: 'relative'
  },

  empty: {
    marginLeft: '230px',
    padding: '30px 0',
  },

  exist: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    marginBottom: "30px",
  },
});

class TimelineStatusesSection extends React.Component {
  // TODO: 通常データだと問題ないですが、
  // 同じ宛先に連続で注文された場合で先の注文のステータス（校了データ作成など）が更新された場合
  // 後の注文のステータスとして表示されてしまうので必要あれば修正する。
  // created_at順で注文のステータスをフォーマットしているので修正するとなると複雑になりそうです。
  // 以下の場合は注文ID: 2に注文受付 -> 校了データ作成と表示されていまいます。（注文ID: 1に表示されるべき）
  // 注文ID: 1, ステータス: 校了データ作成
  // 注文ID: 2, ステータス: 注文受付
  formatStatuses = () => {
    const { statuses } = this.props;

    let result = [];
    const add1 = 1;
    const add2 = 2;
    const add3 = 3;

    for (let i = 0; i < statuses.length; i++) {
      let current = statuses[i];
      let next1 = statuses[i + add1];
      let next2 = statuses[i + add2];
      let next3 = statuses[i + add3];

      // 手紙が注文されました(S) => 1注文サイクルのStart
      // 手紙が発送されました(G) => 1注文サイクルのGoal

      if (
        // 手紙が注文されました(S) -> 校了データが作成されました -> 手紙を印刷中です -> 手紙が発送されました(G)
        current.status_label_type === TimelineLabelType.APPROACH.value &&
        next1 &&
        next1.status_label_type === TimelineLabelType.PROOFREAD_CREATED.value &&
        next2 &&
        next2.status_label_type === TimelineLabelType.ORDER_PRINTING.value &&
        next3 &&
        next3.status_label_type === TimelineLabelType.ORDER_SHIPPED.value
      ) {
        result.push([current, next1, next2, next3]);
        i += add3;
      } else if (
        // 手紙が注文されました(S) -> 校了データが作成されました -> 手紙を印刷中です
        (
          current.status_label_type === TimelineLabelType.APPROACH.value &&
          next1 &&
          next1.status_label_type === TimelineLabelType.PROOFREAD_CREATED.value &&
          next2 &&
          next2.status_label_type === TimelineLabelType.ORDER_PRINTING.value
        ) ||
        // 手紙が注文されました(S) -> (校了データが作成されました or 手紙を印刷中です) -> 手紙が発送されました(G)
        (
          current.status_label_type === TimelineLabelType.APPROACH.value &&
          next1 &&
          (next1.status_label_type === TimelineLabelType.PROOFREAD_CREATED.value || next1.status_label_type === TimelineLabelType.ORDER_PRINTING.value) &&
          next2 &&
          next2.status_label_type === TimelineLabelType.ORDER_SHIPPED.value
        )
      ) {
        result.push([current, next1, next2]);
        i += add2;
      } else if (
        // 手紙が注文されました(S) -> 校了データが作成されました
        (
          current.status_label_type === TimelineLabelType.APPROACH.value &&
          next1 &&
          next1.status_label_type === TimelineLabelType.PROOFREAD_CREATED.value
        ) ||
        // 手紙が注文されました(S) -> 手紙が発送されました(G)
        (
          current.status_label_type === TimelineLabelType.APPROACH.value &&
          next1 &&
          next1.status_label_type === TimelineLabelType.ORDER_SHIPPED.value
        )
      ) {
        result.push([current, next1]);
        i += add1;
      } else if (
        // 手紙が注文されました(S)
        current.status_label_type === TimelineLabelType.APPROACH.value &&
        !next1
      ) {
        result.push([current]);
      } else {
        // 1注文サイクル後、の任意のタイムライン(リアクションなど)
        result.push(current);
      }
    }

    return result;
  }

  calcCount = (status) => {
    const { statuses } = this.props;
    let index = statuses.filter(item => {
      return item.type === TimelineIconType.FOLLOW_CALL_USER_STATUS || item.type === TimelineIconType.RESEARCHER_USER_STATUS
    })
      .findIndex(item => item.id === status.id);

    return index + 1;
  }

  render() {
    const { classes } = this.props;

    const statuses = this.formatStatuses();
    // 一度でもフォローコールアドレスがあるかどうかを判定。なぜならバックエンドでユーザー作成したステータスはフォローコール管理画面で表示させるためfollow_call_order_address_idをいれてるため
    // 例: フォローコール注文 -> レター ->注文 -> ユーザー入力の資料送付をいれたときフォローコール管理にも反映されている。
    const hasFollowCallOrderAddress = statuses.some((statusGroup) => {
      if (Array.isArray(statusGroup)) {
        return statusGroup.some((statusItem) => statusItem && statusItem.follow_call_order_address);
      }
      return statusGroup && statusGroup.follow_call_order_address;
    });

    return (
      <div className={classes.root}>
        <div className={classes.mainContainer}>
          <div className={classes.labelContainer}>
            <span className={classes.label}>
              タイムライン
            </span>
          </div>

          <div className={classes.statuses}>
            {(statuses.length === 0) ?
              <div className={classes.empty}>ステータスがありません。</div> :
              statuses.map((status, i) => {
                return (
                  <div className={classes.exist} key={i}>
                    <TimeStamp status={Array.isArray(status) ? status[0] : status} />
                    <TimelinePanel
                      firstStatus={Array.isArray(status) ? status[0] : status}
                      status={Array.isArray(status) ? status[status.length - 1] : status}
                      followCallCount={Array.isArray(status) ? null : this.calcCount(status)}
                      toggleEditStatusDialog={this.props.toggleEditStatusDialog}
                      hasFollowCallOrderAddress={hasFollowCallOrderAddress}
                      toggleLetterOrderDetailDialog={this.props.toggleLetterOrderDetailDialog}
                      toggleFollowCallDetailDialog={this.props.toggleFollowCallDetailDialog}
                    />
                  </div>
                );
              }
            )}

            {statuses.length > 0 && (
              <TimelineProgress statuses={statuses} />
            )}
            <AddTimeline toggleAddStatusDialog={() => this.props.toggleAddStatusDialog(hasFollowCallOrderAddress)} />
          </div>
        </div>
      </div>
    )
  }
}

TimelineStatusesSection.propTypes = {
  classes: PropTypes.object.isRequired,
  statuses: PropTypes.array,
  toggleAddStatusDialog: PropTypes.func,
  toggleEditStatusDialog: PropTypes.func.isRequired,
  toggleLetterOrderDetailDialog: PropTypes.func.isRequired,
  toggleFollowCallDetailDialog: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    statuses: state.timeline.statuses.toIndexedSeq().toArray(),
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(TimelineStatusesSection));



// WEBPACK FOOTER //
// ./src/components/Timeline/sections/TimelineStatusesSection.jsx